import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  editButton: {
    backgroundColor: "#4A7396",
    color: "white",
    fontSize: "9px",
    fontWeight: "bold",
    padding: "2px 6px",
    minHeight: "16px",
    lineHeight: 1.2,
    borderRadius: "2px",
    border: "1px solid #3a5a7a",
    cursor: "pointer",
    fontFamily: "objektiv-mk2, sans-serif",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#3a5a7a",
    },
  },
});

/**
 * EditButton - Button component for editing properties
 * Can be styled by parent component via customStyle prop.
 * @param {string} [label="EDIT"] - Button text; use "You Added This Property" or "You Edited This Property" when appropriate
 */
export default function EditButton({ onClick, label = "EDIT", customStyle = {}, ...props }) {
  const classes = useStyles();
  const isLongLabel = label !== "EDIT";
  return (
    <button
      className={classes.editButton}
      onClick={onClick}
      style={{ ...customStyle, ...(isLongLabel ? { textTransform: "none", fontSize: "9px" } : {}) }}
      {...props}
    >
      {label}
    </button>
  );
}
